import {autoinject} from "aurelia-framework";
import { EntityController } from "pages/entity/entity-controller";
import { ListItem } from "data/entities/entities";
import { EntityStatuses} from "core/enums";


@autoinject()
export class ListItems {
    constructor(private controller: EntityController) {
        
    }

	saveAndAdd(listItem: ListItem) {
		if (!listItem) return;
		if (listItem.isSaving) return;
		listItem.isSaving = true;
		//console.log("saving" + listItem.text);
         if (listItem.text) {
			listItem.save();
			this.controller.addListItem();
        } else {
            listItem.entityStatusId = EntityStatuses.Archived;
            listItem.save();
            this.controller.removeListItemFromParent(listItem);
        }
        
    }

	
    
}